import { Dispatch } from 'redux';
import { StakingActionEnum, StakingPoolsActionType } from '../reducers/StakingPoolsReducer';
import { UnstakeData } from '../screens/staking/types/staking.types';
import { NetworkId } from '../types/network.types';

export const StakingPoolsActions = {
  setStakedBalance: ({
    balance,
    id,
    networkId,
  }: {
    balance: string;
    id: string;
    networkId: NetworkId;
  }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_STAKED_BALANCE,
        payload: { balance, id, networkId },
      });
    };
  },
  setStakedBalanceUsd: ({
    balance,
    id,
    networkId,
  }: {
    balance: string;
    id: string;
    networkId: NetworkId;
  }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_STAKED_BALANCE_USD,
        payload: { balance, id, networkId },
      });
    };
  },
  setApr: ({ apr, id, networkId }: { apr: string; id: string; networkId: NetworkId }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_APR,
        payload: { apr, id, networkId },
      });
    };
  },
  setTokenBalance: ({
    balance,
    id,
    networkId,
  }: {
    balance: string;
    id: string;
    networkId: NetworkId;
  }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_TOKEN_BALANCE,
        payload: { balance, id, networkId },
      });
    };
  },
  setUnstakeData: ({
    unstakeData,
    id,
    networkId,
  }: {
    unstakeData: UnstakeData;
    id: string;
    networkId: NetworkId;
  }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_UNSTAKE_DATA,
        payload: { unstakeData: { ...unstakeData }, id, networkId },
      });
    };
  },
  setFee: ({ fee, id, networkId }: { fee: number; id: string; networkId: NetworkId }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_FEE,
        payload: { fee, id, networkId },
      });
    };
  },
  setUnlockingTime: ({
    unlockingTime,
    id,
    networkId,
  }: {
    unlockingTime: number;
    id: string;
    networkId: NetworkId;
  }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_UNLOCKING_TIME,
        payload: { unlockingTime, id, networkId },
      });
    };
  },
  setRewardBalance: ({
    rewardBalance,
    id,
    networkId,
  }: {
    rewardBalance: string;
    id: string;
    networkId: NetworkId;
  }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_REWARD_BALANCE,
        payload: { rewardBalance, id, networkId },
      });
    };
  },
  setClaimUnlockTime: ({
    claimUnlockTime,
    id,
    networkId,
  }: {
    claimUnlockTime: string;
    id: string;
    networkId: NetworkId;
  }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_CLAIM_UNLOCK_TIME,
        payload: { claimUnlockTime, id, networkId },
      });
    };
  },
  setEstimatedDailyReward: ({
    dailyReward,
    id,
    networkId,
  }: {
    dailyReward: string;
    id: string;
    networkId: NetworkId;
  }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_ESTIMATED_DAILY_REWARD,
        payload: { dailyReward, id, networkId },
      });
    };
  },
  setEarnedReward: ({
    rewardsEarned,
    id,
    networkId,
  }: {
    rewardsEarned: string;
    id: string;
    networkId: NetworkId;
  }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_REWARDS_EARNED,
        payload: { rewardsEarned, id, networkId },
      });
    };
  },
  setUnstakedBalance: ({
    unstakedBalance,
    id,
    networkId,
  }: {
    unstakedBalance: string;
    id: string;
    networkId: NetworkId;
  }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_UNSTAKED_BALANCE,
        payload: { unstakedBalance, id, networkId },
      });
    };
  },
  setLpTokenRate: ({ rate, id, networkId }: { rate: number; id: string; networkId: NetworkId }) => {
    return async (dispatch: Dispatch<StakingPoolsActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_LP_RATE,
        payload: { rate, id, networkId },
      });
    };
  },
};
